import { Component, Input } from '@angular/core';
import { Table } from '../../../../models/reporting';

@Component({
    selector: 'detailed-table',
    templateUrl: './detailed-table.component.html',
    styleUrls: ['./table.component.scss']
})
export class DetailedTableComponent {
    @Input() table: Table;

}